import { fetchJSON } from '@bonnet/next/fetch';

import { getReference } from '@atc/bonnet-reference';

const getYmmtQueryParam = async ({ makeCodeList, modelCodeList, startYear, endYear }) => {
    const kbbParams = [];

    let makeId;
    let modelId;

    if (makeCodeList) {
        const { payload: makePayload = [] } = await getReference('makeCode');
        ({ kbbCode: makeId } = makePayload.find(({ code }) => makeCodeList === code) || {});
    }

    if (modelCodeList && makeCodeList) {
        const { payload: modelPayload = [] } = await getReference('modelCode', { makeCode: makeCodeList });
        ({ kbbCode: modelId } = modelPayload.find(({ code }) => modelCodeList === code) || {});
    }

    if (makeId) {
        kbbParams.push(makeId);
    }

    if (modelId) {
        kbbParams.push(modelId);
    }

    if (startYear && (startYear === endYear)) {
        kbbParams.push(endYear);
    }

    return kbbParams.join('/');
};

export default function withKbbEditorialFetcher() {
    return async (ctx) => {
        const {
            srp_expert_reviews: [enableExpertReviews],
        } = ctx.useFeatures([
            'srp_expert_reviews',
        ]);

        if (!enableExpertReviews) {
            return;
        }

        const { makeCodeList, modelCodeList } = ctx.query;
        const showReviews = ![makeCodeList, modelCodeList].some((value) => Array.isArray(value) && value.length > 1);

        if (!showReviews) {
            return;
        }

        ctx.fetchCompositeJSON.addFetch('editorialReviews', fetchJSON('https://www.kbb.com/wp-json/wp/v2/kbb_expert_review/', {
            query: {
                ymmt: await getYmmtQueryParam(ctx.query),
                _embed: true,
            },
            circuitBreaker: {
                id: 'wp-expert-review',
                timeout: 3000,
                resetTimeout: 30000,
                fallback: {},
            },
        }));
    };
}
